module.exports = __webpack_public_path__ + "CriticalTreasures.webp?35c2d13b52f1919bce3de4eb2b839a52";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/CriticalTreasures.webp
// module id = 69
// module chunks = 0